import React, {useState} from "react";
import AvatarDialog from "../../dialogs/AvatarDialog";
import {Button} from "@mui/material";
import {connect} from "react-redux";

function ProfilePhotoEdit({ mindfile, avatarUpdating }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div>
      <Button
        onClick={() => setDialogOpen(true)}
        variant="contained"
        color="primary"
      >
        {avatarUpdating ? 'Uploading...' : 'Upload a profile photo'}
      </Button>
      <AvatarDialog
        isOpen={dialogOpen}
        closeDialog={() => setDialogOpen(false)}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  mindfile: state.mindfile,
  avatarUpdating: state.mindfile.picturesUploading > 0,
});

export default connect(mapStateToProps)(ProfilePhotoEdit);
